import React, { PropTypes, Component } from 'react'
import constants from 'constants'
import { Progress } from '.'
// import moment from 'moment'
import { format } from 'date-fns'

class InterimAssessment extends Component {
  static propTypes = {
    handleInterimSelfAssessment: PropTypes.func.isRequired,
    partnerPlan: PropTypes.object.isRequired,
    selectedPlan: PropTypes.object.isRequired,
  }
  render() {
    const {
      partnerPlan,
      selectedPlan,
      handleInterimSelfAssessment,
    } = this.props

    const steps = [
      {
        key: 1,
        label: constants.PARTNERPLAN.STEPS.UPLOAD,
        desc: `${constants.PARTNERPLAN.STATUS.UPLOADED}: ${(partnerPlan.partnerPlan.planUploadedDate ?
          format(new Date(partnerPlan.partnerPlan.planUploadedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 2,
        label: constants.PARTNERPLAN.STEPS.SUBMIT,
        desc: `${constants.PARTNERPLAN.STATUS.SUBMITTED}: ${(partnerPlan.partnerPlan.planSubmittedDate ?
          format(new Date(partnerPlan.partnerPlan.planSubmittedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 3,
        label: constants.PARTNERPLAN.STEPS.AGREED,
        desc: `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_AGREED}: ${(partnerPlan.partnerPlan.planAgreedDate ?
          format(new Date(partnerPlan.partnerPlan.planAgreedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        /* desc2: `${partnerPlan.partnerPlan.planAgreedWithCounsellee ? constants.PARTNERPLAN.PROGRESS_LABEL.AGREED_WITH_COUNSELLEE : ''}`, */
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 4,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT,
        desc: '',
        isDone: (partnerPlan.partnerPlan.assessmentFlag === true),
        isCurrent: (partnerPlan.partnerPlan.assessmentFlag === true),
        actions: [
          {
            label: 'SUPPORTING DOCUMENTS',
            onClick: handleInterimSelfAssessment,
            // active: true,
            show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.MYPLANS && partnerPlan.partnerPlan.assessmentFlag === true),
          },
        ],
      },
      {
        key: 5,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_SUBMITTED,
        desc: '',
        isDone: false,
        isCurrent: false,
        actions: [],
      },
      {
        key: 6,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_AGREED,
        desc: '',
        isDone: false,
        isCurrent: false,
        actions: [],
      },
      {
        key: 7,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT,
        desc: '',
        isDone: false,
        isCurrent: false,
        actions: [],
      },
      {
        key: 8,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_SUBMITTED,
        desc: '',
        isDone: false,
        isCurrent: false,
        actions: [],
      },
      {
        key: 9,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_AGREED,
        desc: '',
        isDone: false,
        isCurrent: false,
        actions: [],
      },
    ]

    return (
      <Progress steps={steps} />
    )
  }
}

export default InterimAssessment



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/InterimAssessment.js